(function() { window.GUID_8a47d6ef_e1bd_43c2_83cf_ef31084ca239 = { getGuid: function() { return "8a47d6ef-e1bd-43c2-83cf-ef31084ca239"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PersonaType;
        (function (PersonaType) {
            PersonaType[PersonaType["User"] = 0] = "User";
            PersonaType[PersonaType["Player"] = 1] = "Player";
            PersonaType[PersonaType["Team"] = 2] = "Team";
            PersonaType[PersonaType["EntityBase"] = 4] = "EntityBase";
            PersonaType[PersonaType["Empty"] = 8] = "Empty";
        })(PersonaType = Enumeration.PersonaType || (Enumeration.PersonaType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PersonaType.pre.js.map
